import React from 'react'
import styled from '../../utils/styled'

const StyledContainer = styled('div')`
  margin: 0 auto;
  width: 100%;
  max-width: ${props => props.theme.widths.sm};
`

const Container: React.FC = ({ children }) => <StyledContainer>{children}</StyledContainer>

export default Container
